import React, { useState } from 'react';

import { MainContainer } from '../../styles/styles';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import { useI18n } from '../../hooks/useI18n';
import ActionButton from '../../presentation/components/ActionButton/ActionButton';
import {
  cropConnectApiClient,
  FileParameter,
} from '../../services/cropConnectApiClient';

const AdministrationStatistics = () => {
  const { t } = useI18n();
  const [bpNumbersFile, setBpNumbersFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setBpNumbersFile(file);
  };

  const createFileParameter = async (file: File): Promise<FileParameter> => {
    return {
      data: new Blob([await file.text()], { type: file.type }),
      fileName: file.name,
    };
  };

  const handleBpStatistics = async () => {
    try {
      if (!bpNumbersFile) {
        throw new Error('No file selected for BP statistics');
      }
      const fileParameter = await createFileParameter(bpNumbersFile);
      await cropConnectApiClient.createBusinessPartnerOnboardingStatistics(
        fileParameter
      );
    } catch (error) {
      console.error('Error generating BP statistics:', error);
    }
  };

  const handleUserStatistics = async () => {
    try {
      if (!bpNumbersFile) {
        throw new Error('No file selected for User statistics');
      }
      const fileParameter = await createFileParameter(bpNumbersFile);
      await cropConnectApiClient.createUserOnboardingStatistics(fileParameter);
    } catch (error) {
      console.error('Error generating user statistics:', error);
    }
  };

  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.administration_statistics_title)} />
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <br />
      <ActionButton
        fullWidth={true}
        variant="accept-blue"
        buttonText={t(
          TranslationKeys.administration_statistics_get_bp_statistic_button
        )}
        onClickAction={handleBpStatistics}
      />
      <br />
      <ActionButton
        fullWidth={true}
        variant="accept-blue"
        buttonText={t(
          TranslationKeys.administration_statistics_get_user_statistic_button
        )}
        onClickAction={handleUserStatistics}
      />
    </MainContainer>
  );
};

export default AdministrationStatistics;
